<template>
  <b-modal id="modal-filters" centered title="Filtros" title-class="font-18">
    <div class="row">
      <!-- Status Select -->
      <div class="col-12 col-md-6">
        <b-form-group label="Status">
          <b-form-select
            v-model="status"
            size="sm"
            :options="options"
          ></b-form-select>
        </b-form-group>
      </div>
      <!-- Method Select -->
      <div class="col-12 col-md-6">
        <b-form-group label="Método">
          <b-form-select
            v-model="method"
            size="sm"
            :options="optionsMethod"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <!-- Period Data Picker -->
      <div class="col-12 col-md-6">
        <b-form-group label="Período">
          <date-range-picker
            id="range"
            ref="picker"
            v-model="date"
            class="w-100"
            :locale-data="localeDate"
            :show-week-numbers="false"
            :show-dropdowns="true"
            :auto-apply="false"
            :ranges="dateRanges"
          >
            <template
              v-if="date.startDate && date.endDate"
              v-slot:input="picker"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
            <template v-else v-slot:input> Período </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <!-- Sellers Type Select -->
      <div class="col-12 col-md-6">
        <b-form-group label="Vendedor">
          <b-form-select
            v-model="userId"
            size="sm"
            :options="optionsSeller"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    <!-- Footer -->
    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel">Cancelar</b-button>
      <b-button variant="success" @click="onSubmit">Ok</b-button>
    </template>
  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import UserService from '@services/resources/UserService'
import moment from 'moment'

var service = UserService.build()

export default {
  components: { DateRangePicker },
  data() {
    /**
     * Temporário:
     * 
     * Adicionado datas fixas para evitar problemas de performance e trazer todos 
     * os registros do banco de dados.
     */
    let today = new Date();
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
    const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0, 0, 0, 0, 0);

    return {
      users: [],
      userId: null,
      date: {
        startDate: firstDayOfCurrentMonth.toString(),// '01/03/2025', 
        endDate: lastDayOfCurrentMonth.toString(), // '31/03/2025',
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        firstDay: 0,
      },
      status: null,
      options: [
        { value: null, text: 'Todos' },
        { value: 'paid', text: 'Paga' },
        { value: 'refused', text: 'Recusada' },
        { value: 'waiting_payment', text: 'Processando' },
        { value: 'refunded', text: 'Reembolsada' },
      ],
      method: null,
      optionsMethod: [
        { value: null, text: 'Todos' },
        { value: 'CREDIT_CARD', text: 'Cartão de crédito' },
        { value: 'BOLETO', text: 'Boleto' },
        { value: 'PIX', text: 'PIX' },
        { value: 'PAYPAL', text: 'PayPal' },
        { value: 'GOOGLE_PAY', text: 'Google Pay' },
        { value: 'APPLE_PAY', text: 'Apple Pay' },
      ],
      optionsSeller: [{ value: null, text: 'Todos' }],
    }
  },
  computed: {
    /**
     * Data picker data setup
     * @params no params
     * @return Object - data range setup
     * @author Sandro Souza
     */
    dateRanges() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth() + 1, 0),
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      }
    },
  },
  mounted() {
    this.fetchUsers()
  },
  methods: {
    /**
     * Brings all types of sellers, if any, and adds in list of options of sellers select
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    fetchUsers() {
      this.loading = true

      service
        .search()
        .then((resp) => {
          resp.data.forEach((element) => {
            this.optionsSeller.push({
              value: element.id,
              text: element.name,
            })
          })
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    /**
     * Fires when user presses the OK button. Sends the filter data to the parent component to make the request with the filters applied
     * @params no params
     * @return no return
     * @author Sandro Souze
     */
    onSubmit() {
      let data = {
        date_start: this.date.startDate
          ? moment(this.date.startDate).format('YYYY-MM-DD')
          : null,
        date_end: this.date.endDate
          ? moment(this.date.endDate).format('YYYY-MM-DD')
          : null,
        status: this.status,
        method: this.method,
        user_id: this.userId,
      }

      this.$emit('close', data)
      this.$bvModal.hide('modal-filters')
    },
  },
}
</script>